import React, { useState, useEffect } from "react";
import {
  collection,
  getDocs,
  query,
  where,
  setDoc,
  doc,
  addDoc,
} from "firebase/firestore";
import { db, storage } from "../../Firebase/Firebase-config";
import {
  ref,
  listAll,
  getDownloadURL,
  uploadBytes,
  storageRef,
} from "firebase/storage";
import TableConfig from "./TableConfig";
import moment from "moment/moment";

const Admin = () => {
  // const [allBlogs, setAllBlogs] = useState([])
  const dbCollectionRef = collection(db, "blogs");
  const imageListRef = ref(storage, "blog-images/");
  const [isAddNew, setIsAddNew] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [isLoader, setIsLoader] = useState(false);

  const [img, setImg] = useState();
  const [values, setValues] = useState({
    tittle: "",
    description: "",
    date: "",
    comments: [
      {
        uName: "",
        uComments: "",
      },
    ],
    likes: 0,
    thumbnail: "",
    category: "all-post",
    delete: false,
  });

  const create = async () => {
    setIsLoader(true);

    if (values.tittle && values.description && values.thumbnail) {
      await addDoc(dbCollectionRef, { ...values });
      setIsLoader(false);
      console.log("upload");
      //image uploading
      const uploadRef = ref(
        storage,
        `blog-images/${values.tittle + "_" + img.name}`
      );
      uploadBytes(uploadRef, img).then((snapshot) => {
        console.log("Uploaded a blob or file!", snapshot);
      });

      setIsAddNew(false);
    } else {
      console.log("fill all details");
    }
  };

  useEffect(() => {
    setValues((date) => ({
      ...date,
      date: moment().format("DD-MM-YYYY hh:mm:ss"),
    }));
    if (img) {
      setValues((thumbnail) => ({
        ...thumbnail,
        thumbnail: values.tittle + "_" + img.name,
      }));
    }
    // console.log(moment().format('DD-MM-YYYY hh:mm:ss'))
  }, [img]);

  return (
    <>
      <div className="flex p-2 items-center flex-col space-y-3">
        <div className="flex w-full justify-end pr-5 md:pr-16">
          <button
            className="bg-primary py-1 px-4 shadow-md shadow-secondary hover:shadow-primary border-2"
            onClick={() => {
              setIsAddNew(true);
            }}
          >
            Add New
          </button>
          <button
            className="bg-primary py-1 px-4 shadow-md shadow-secondary hover:shadow-primary border-2"
            onClick={() => {
              setRefresh(!refresh);
            }}
          >
            Refresh
          </button>
        </div>
        <div className="w-11/12 h-1/2 border-2">
          <TableConfig refresh={(refresh, isAddNew)} />
        </div>
      </div>
      {isAddNew && (
        <div
          className={`absolute inset-0 z-10 overflow-hi dden bg-transparent bg-opacity-60 backdrop-blur-sm bg-white flex flex-col justify-center items-center ${
            isAddNew
              ? "translate-x-0 transform duration-600"
              : "translate-x-full"
          }`}
        >
          <div className="flex flex-col md:w-2/4 w-11/12 space-y-4 border-2 p-5 bg-secondary shadow-lg drop-shadow-xl shadow-primary">
            <div className="relative w-full flex justify-end -mt-8 ml-7 rounded-full">
              <svg
                className="w-7 h-7 p-1 border-2 bg-white hover:cursor-pointer"
                onClick={() => {
                  setIsAddNew(false);
                }}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>
            <span>Tittle</span>
            <input
              type="text"
              className="border-2 border-gray-400 h-8"
              onChange={(e) => {
                setValues((tittle) => ({
                  ...tittle,
                  tittle: e.target.value,
                }));
              }}
            />
            <span>Description</span>
            <textarea
              name="blog"
              id="blog"
              cols="30"
              rows="10"
              className="border-2 border-gray-400"
              onChange={(e) => {
                setValues((description) => ({
                  ...description,
                  description: e.target.value,
                }));
              }}
            ></textarea>
            <span>Upload Image</span>
            <input
              type="file"
              className="border-2 border-gray-400 h-8"
              onChange={(e) => {
                setImg(e.target.files[0]);
              }}
              accept="image/*"
            />
            <div className="space-x-4">
              <label htmlFor="category-select">Select a category:</label>
              <select
                className="bg-medium p-1 border-2"
                id="category-select"
                value={values.category}
                onChange={(e) => {
                  setValues((category) => ({
                    ...category,
                    category: e.target.value,
                  }));
                }}
              >
                <option value="all-post">
                  Choose a category "(default: All Post)"
                </option>
                <option value="health-wellness">Health & Wellness</option>
                <option value="travel">Travel</option>
                <option value="culture">Culture</option>
              </select>
            </div>
            <button
              className="border-2 bg-primary py-2 shadow-lg hover:shadow-primary"
              onClick={() => {
                create();
              }}
            >
              {!isLoader ? "Submit" : "Loading..."}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Admin;
